import { render } from "./filtroResultadosFinais.vue?vue&type=template&id=5b16cf41&scoped=true"
import script from "./filtroResultadosFinais.vue?vue&type=script&lang=js"
export * from "./filtroResultadosFinais.vue?vue&type=script&lang=js"

import "./filtroResultadosFinais.vue?vue&type=style&index=0&id=5b16cf41&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b16cf41"]])

export default __exports__